import React from "react";
import Users from "../components/pages/Users/Users";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const UsersLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <Users />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default UsersLayout;
